<template>
    <div>
        <div class="columns">
            <div class="column is-4">

                <form-group type="checkbox"
                            label="Enabled"
                            id="enabled"
                            v-model="form.enabled"
                            :error="form.errors.get('enabled')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Code"
                            id="code"
                            v-model="form.code"
                            :error="form.errors.get('code')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Name"
                            id="name"
                            v-model="form.name"
                            :error="form.errors.get('name')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="textarea"
                            label="Description"
                            id="description"
                            v-model="form.description"
                            :error="form.errors.get('description')"
                            @event="form.listen(form, $event)">
                </form-group>

                <h2>Product Discount</h2>
                <label>Require these products for the discount to apply:</label>
                <div v-if="form.applicable_product_skus === null"><strong>None selected</strong></div>
                <div v-else>
                    <div v-for="sku in form.applicable_product_skus.split(',')">
                        #{{ sku }} - <a @click="removeApplicableProduct(sku)">Remove</a>
                    </div>
                </div>
                <form-group type="checkbox"
                            label="Only apply subtotal and shipping discount amounts to the selected products"
                            id="product_discount_only"
                            v-model="form.product_discount_only"
                            :error="form.errors.get('product_discount_only')"
                            @event="form.listen(form, $event)">
                </form-group>
                <select name="add_applicable_products" class="input" v-model="selectedProduct">
                    <option v-for="product in availableProducts" :value="product.sku">
                        {{ product.sku }} - {{ product.short_name }}
                    </option>
                </select>
                <br/>
                <button type="button" class="button is-default" @click="addApplicableProduct()">Add product</button>
            </div>
            <div class="column">
                <h2>Tier 1 Discount</h2>
                <div class="columns">
                    <div class="column is-3">
                        <form-group type="text"
                                    label="Minimum Items in Cart"
                                    id="tier1_minimum_cart_items"
                                    v-model="form.tier1_minimum_cart_items"
                                    :error="form.errors.get('tier1_minimum_cart_items')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="text"
                                    label="Minimum Subtotal"
                                    id="tier1_minimum_subtotal"
                                    v-model="form.tier1_minimum_subtotal"
                                    :error="form.errors.get('tier1_minimum_subtotal')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                    </div>
                    <div class="column">
                        <form-group type="text"
                                    :label="'Subtotal Discount Amount (' + (form.tier1_subtotal_discount_fixed_or_percent ? 'fixed)' : 'percent)')"
                                    id="tier1_subtotal_discount_amount"
                                    v-model="form.tier1_subtotal_discount_amount"
                                    :error="form.errors.get('tier1_subtotal_discount_amount')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="checkbox"
                                    label="Subtotal Discount is a fixed amount"
                                    id="tier1_subtotal_discount_fixed_or_percent"
                                    v-model="form.tier1_subtotal_discount_fixed_or_percent"
                                    :error="form.errors.get('tier1_subtotal_discount_fixed_or_percent')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="text"
                                    :label="'Shipping Discount Amount (' + (form.tier1_shipping_discount_fixed_or_percent ? 'fixed)' : 'percent)')"
                                    id="tier1_shipping_discount_amount"
                                    v-model="form.tier1_shipping_discount_amount"
                                    :error="form.errors.get('tier1_shipping_discount_amount')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="checkbox"
                                    label="Shipping Discount is a fixed amount"
                                    id="tier1_shipping_discount_fixed_or_percent"
                                    v-model="form.tier1_shipping_discount_fixed_or_percent"
                                    :error="form.errors.get('tier1_shipping_discount_fixed_or_percent')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                    </div>
                </div>

                <hr/>

                <h2>Tier 2 Discount</h2>
                <div class="columns">
                    <div class="column is-3">
                        <form-group type="text"
                                    label="Minimum Items in Cart"
                                    id="tier2_minimum_cart_items"
                                    v-model="form.tier2_minimum_cart_items"
                                    :error="form.errors.get('tier2_minimum_cart_items')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="text"
                                    label="Minimum Subtotal"
                                    id="tier2_minimum_subtotal"
                                    v-model="form.tier2_minimum_subtotal"
                                    :error="form.errors.get('tier2_minimum_subtotal')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                    </div>
                    <div class="column">
                        <form-group type="text"
                                    :label="'Subtotal Discount Amount (' + (form.tier2_subtotal_discount_fixed_or_percent ? 'fixed)' : 'percent)')"
                                    id="tier2_subtotal_discount_amount"
                                    v-model="form.tier2_subtotal_discount_amount"
                                    :error="form.errors.get('tier2_subtotal_discount_amount')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="checkbox"
                                    label="Subtotal Discount is a fixed amount"
                                    id="tier2_subtotal_discount_fixed_or_percent"
                                    v-model="form.tier2_subtotal_discount_fixed_or_percent"
                                    :error="form.errors.get('tier2_subtotal_discount_fixed_or_percent')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="text"
                                    :label="'Shipping Discount Amount (' + (form.tier2_shipping_discount_fixed_or_percent ? 'fixed)' : 'percent)')"
                                    id="tier2_shipping_discount_amount"
                                    v-model="form.tier2_shipping_discount_amount"
                                    :error="form.errors.get('tier2_shipping_discount_amount')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="checkbox"
                                    label="Shipping Discount is a fixed amount"
                                    id="tier2_shipping_discount_fixed_or_percent"
                                    v-model="form.tier2_shipping_discount_fixed_or_percent"
                                    :error="form.errors.get('tier2_shipping_discount_fixed_or_percent')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                    </div>
                </div>

                <hr/>

                <h2>Tier 3 Discount</h2>
                <div class="columns">
                    <div class="column is-3">
                        <form-group type="text"
                                    label="Minimum Items in Cart"
                                    id="tier3_minimum_cart_items"
                                    v-model="form.tier3_minimum_cart_items"
                                    :error="form.errors.get('tier3_minimum_cart_items')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="text"
                                    label="Minimum Subtotal"
                                    id="tier3_minimum_subtotal"
                                    v-model="form.tier3_minimum_subtotal"
                                    :error="form.errors.get('tier3_minimum_subtotal')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                    </div>
                    <div class="column">
                        <form-group type="text"
                                    :label="'Subtotal Discount Amount (' + (form.tier3_subtotal_discount_fixed_or_percent ? 'fixed)' : 'percent)')"
                                    id="tier3_subtotal_discount_amount"
                                    v-model="form.tier3_subtotal_discount_amount"
                                    :error="form.errors.get('tier3_subtotal_discount_amount')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="checkbox"
                                    label="Subtotal Discount is a fixed amount"
                                    id="tier3_subtotal_discount_fixed_or_percent"
                                    v-model="form.tier3_subtotal_discount_fixed_or_percent"
                                    :error="form.errors.get('tier3_subtotal_discount_fixed_or_percent')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="text"
                                    :label="'Shipping Discount Amount (' + (form.tier3_shipping_discount_fixed_or_percent ? 'fixed)' : 'percent)')"
                                    id="tier3_shipping_discount_amount"
                                    v-model="form.tier3_shipping_discount_amount"
                                    :error="form.errors.get('tier3_shipping_discount_amount')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                        <form-group type="checkbox"
                                    label="Shipping Discount is a fixed amount"
                                    id="tier3_shipping_discount_fixed_or_percent"
                                    v-model="form.tier3_shipping_discount_fixed_or_percent"
                                    :error="form.errors.get('tier3_shipping_discount_fixed_or_percent')"
                                    @event="form.listen(form, $event)">
                        </form-group>
                    </div>
                </div>

                <div class="has-text-centered">
                    <br/>
                    If no minimum item counts or subtotals are specified, the highest tiered discount will always be used.
                    <br/>
                    (only if multiple tiers are specified)
                    <br/>
                </div>
            </div>
        </div>

        <button v-if="create" type="button" class="button is-primary" @click="submitCreate()">Create</button>
        <button v-else type="button" class="button is-primary" @click="submitUpdate()">Update</button>
    </div>
</template>

<script>
    import Form from "../../helpers/Form"
    import {mapGetters} from "vuex"
    import {CREATE_DISCOUNT, UPDATE_DISCOUNT} from "../../store/mutation-types"
    export default {
        props: {
            discount: {
                type: [String, Object], default: () => {
                    return {
                        enabled: null,
                        name: null,
                        description: null,
                        code: null,
                        tier1_subtotal_discount_amount: null,
                        tier1_subtotal_discount_fixed_or_percent: null,
                        tier1_shipping_discount_amount: null,
                        tier1_shipping_discount_fixed_or_percent: null,
                        tier2_subtotal_discount_amount: null,
                        tier2_subtotal_discount_fixed_or_percent: null,
                        tier2_shipping_discount_amount: null,
                        tier2_shipping_discount_fixed_or_percent: null,
                        tier3_subtotal_discount_amount: null,
                        tier3_subtotal_discount_fixed_or_percent: null,
                        tier3_shipping_discount_amount: null,
                        tier3_shipping_discount_fixed_or_percent: null,
                        applicable_product_skus: null,
                        product_discount_only: null,
                        tier1_minimum_cart_items: null,
                        tier2_minimum_cart_items: null,
                        tier3_minimum_cart_items: null,
                        tier1_minimum_subtotal: null,
                        tier2_minimum_subtotal: null,
                        tier3_minimum_subtotal: null,
                    }
                }
            },
            create: {type: [Boolean], default: false}
        },
        data() {
            return {
                form: new Form(this, this.discount, this.create ? CREATE_DISCOUNT : UPDATE_DISCOUNT),
                selectedProduct: null,
            }
        },
        computed: Object.assign({}, mapGetters(['products']), {
            availableProducts() {
                let usedProducts = this.form.applicable_product_skus === null
                    ? []
                    : this.form.applicable_product_skus.split(',')

                return this.products.filter(product => {
                    return usedProducts.indexOf(product.sku) === -1
                })
            }
        }),
        methods: {
            addApplicableProduct() {
                if (this.selectedProduct !== null) {
                    let sku_array = this.form.applicable_product_skus !== null
                        ? this.form.applicable_product_skus.split(',')
                        : []
                    if (sku_array.indexOf(this.selectedProduct) === -1) {
                        sku_array.push(this.selectedProduct)
                        this.form.applicable_product_skus = sku_array.join(',')
                    }
                }
            },
            removeApplicableProduct(sku) {
                let sku_array = this.form.applicable_product_skus !== null
                    ? this.form.applicable_product_skus.split(',')
                    : []
                if (sku_array.indexOf(sku) !== -1) {
                    sku_array.splice(sku_array.indexOf(sku), 1)
                    this.form.applicable_product_skus = sku_array.length === 0 ? null : sku_array.join(',')
                }
            },
            submitCreate() {
                this.$store.dispatch(CREATE_DISCOUNT, this.form.data())
                    .then(data => {
                        this.$emit('saved', data)
                    })
            },
            submitUpdate() {
                this.$store.dispatch(UPDATE_DISCOUNT, {discount: this.discount, newDiscount: this.form.data()})
                    .then(data => {
                        this.$emit('saved', data)
                    })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// DiscountForm.vue?0dc21986